var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouterIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.2335L38 17.2334C39.0609 17.2334 40.0783 17.6548 40.8284 18.405C41.5786 19.1551 42 20.1725 42 21.2334V27.2334C42 28.2943 41.5786 29.3117 40.8284 30.0618C40.0783 30.812 39.0609 31.2334 38 31.2334H10C8.93913 31.2334 7.92172 30.812 7.17157 30.0618C6.42143 29.3117 6 28.2943 6 27.2334V21.2334C6 20.1725 6.42143 19.1551 7.17157 18.405C7.92172 17.6548 8.93913 17.2335 10 17.2335ZM10 27.2334V21.2334H24H38V27.2334H10Z",
    fill: "#244C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.9658V23.9455M24 23.9658V23.9455M30 23.9658V23.9455",
    stroke: "#244C84",
    strokeWidth: 4.06416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouterIconNew);
export default __webpack_public_path__ + "static/media/router_icon_new.23e598fa9a582dea5ce3d0c5d53e3d55.svg";
export { ForwardRef as ReactComponent };